const ga4Fn = () => (window ? window['ga4'] : undefined);

export const ga4Init = () => {
  if (!ga4Fn()) {
    const script = document.createElement('script');
    const scriptSrc = document.createElement('script');
    scriptSrc.async = true;
    scriptSrc.src = 'https://www.googletagmanager.com/gtag/js?id=UA-105891753-2';

    script.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-105891753-2');
    `;

    document.head.appendChild(scriptSrc);
    document.head.appendChild(script);
  }
};
